<template>
  <div v-can="['ADMIN', 'SYSADMIN', 'MANAGER', 'FRONTDESK', 'DASHBOARD', 'USER']">
    <div class="row px-0">
      <TwInput label="Busca">
        <b-input-group>
          <b-input-group-prepend is-text
            ><i class="fas fa-search"></i>
          </b-input-group-prepend>
          <input
            v-model="filter"
            type="search"
            class="form-control"
            style="max-width: 900px"
            id="filterInput"
            placeholder="Buscar"
          />
        </b-input-group>
      </TwInput>

      <div class="col-2 d-flex flex-column-reverse pb-3">
        <b-button
          id="addEmployeebtn"
          style="background-color: #4e01d6"
          v-can="['ADMIN', 'SYSADMIN', 'MANAGER', 'DASHBOARD', 'USER']"
          href="#"
          @click="
            () => {
              this.$router.push({ name: 'customer-employee-add' });
            }
          "
          >Adicionar</b-button
        >
      </div>
      <div class="col-2 d-flex flex-column-reverse pb-3">
        <b-button
          style="background-color: #4e01d6"
          v-can="['ADMIN', 'SYSADMIN', 'MANAGER', 'DASHBOARD', 'USER']"
          href="#"
          data-toggle="modal"
          data-target="#modalDeleteEmployees"
          >Excluir</b-button
        >
      </div>
      <div class="col-2 d-flex flex-column-reverse pb-3">
        <b-button
          style="background-color: #4e01d6"
          v-can="['ADMIN', 'SYSADMIN', 'MANAGER', 'DASHBOARD', 'USER']"
          href="#"
          @click="
            () => {
              this.$router.push({ name: 'customer-import-employee' });
            }
          "
          >Importar</b-button
        >
      </div>
    </div>
    <div>
      <Modal
        id="modalDeleteEmployee"
        title="Excluir colaborador"
        v-bind:msg="
          'Tem certeza que deseja excluir ' + employeeDelete.name + '?'
        "
        button="Excluir"
        :method="deleteEmployee"
      />
      <Modal
        id="modalDeleteEmployees"
        title="Excluir colaboradores"
        v-bind:msg="'Tem certeza que deseja excluir todos os colaboradores ?'"
        button="Excluir"
        :method="deleteEmployees"
      />
    </div>

    <b-table
      responsive="sm"
      striped
      borderless
      hover
      class="mt-3 rounded"
      no-sort-reset
      ref="selectableTable"
      sticky-header="610px"
      show-empty
      empty-text="Nenhum registro encontrado"
      empty-filtered-text="Nenhum registro encontrado para essa busca"
      head-variant="light"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortByEmployees"
      :busy="load"
      :filter="filter"
      :fields="fieldsEmployees"
      :items="customerEmployees"
      @filtered="onFiltered"
      @context-changed="changeBsTableState"
    >
      <template v-slot:table-colgroup>
        <col
          v-for="field in fieldsEmployees"
          :key="field.key"
          :style="{
            width: field.key === 'actions' ? '100px' : '550px',
          }"
        />
      </template>
      <template v-slot:table-busy>
        <div class="text-center my-2">
          <strong>
            <i class="fas fa-sync-alt fa-spin"></i>
          </strong>
        </div>
      </template>
      <template v-slot:cell(cellphone)="data">{{
        formatCellphone(data.item.cellphone)
      }}</template>
      <template v-slot:cell(tag)="data">
        <span v-if="data.item.tag">
          <!-- {{ data.item.tag.tag_label }} -->
          Tag: {{ data.item.tag.tag_label }}<br />
          Mac: {{ data.item.tag.mac_address }}<br />
        </span>
      </template>
      <template v-slot:cell(tasg)="data">
        <span v-if="data.item.tag">
          <!-- {{ data.item.tag.tag_label }} -->
          Tag: {{ data.item.tag.tag_label }}<br />
          Mac: {{ data.item.tag.mac_address }}<br />
        </span>
      </template>
      <template v-slot:cell(actions)="data">
        <a
          id="deleteEmployee"
          v-can="['ADMIN', 'SYSADMIN', 'MANAGER', 'DASHBOARD', 'USER']"
          @click="employeeDelete = data.item"
          href="#"
          class="mr-3"
          data-toggle="modal"
          data-target="#modalDeleteEmployee"
          title="Excluir"
        >
          <i class="far fa-trash-alt iconspace"></i>
        </a>
        <router-link
          class="mr-3"
          id="addtag"
          :to="{
            name: 'customer-employee-add-tags',
            params: {
              customerId: customer ? customer.id : -1,
              employeeId: data.item.id,
            },
          }"
          title="Associar tags"
        >
          <i class="fas fa-tag iconspace"></i>
        </router-link>
        <router-link
          v-can="['ADMIN', 'SYSADMIN', 'MANAGER', 'DASHBOARD', 'USER']"
          :to="{
            name: 'customer-employee-edit',
            params: {
              customerId: customer ? customer.id : -1,
              employeeId: data.item.id,
            },
          }"
          title="Editar"
          id="customer-employee-edit-a"
        >
          <i id="editEmployee" class="fas fa-pen iconspace"></i>
        </router-link>
      </template>
    </b-table>

    <div class="row">
      <div v-if="rows" class="col-12 col-md-4 mb-2 pt-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="pagination"
        ></b-pagination>
      </div>
      <div class="col-12 col-md-8">
        <div class="btn-group" role="group">
          <b-dropdown
            variant="primary"
            v-model="perPage"
            :text="`Linhas: ${perPage}`"
          >
            <b-dropdown-item
              href="#"
              @click="
                () => {
                  this.perPage = 10;
                }
              "
              >10</b-dropdown-item
            >
            <b-dropdown-item
              href="#"
              @click="
                () => {
                  this.perPage = 20;
                }
              "
              >20</b-dropdown-item
            >
            <b-dropdown-item
              href="#"
              @click="
                () => {
                  this.perPage = 50;
                }
              "
              >50</b-dropdown-item
            >
            <b-dropdown-item
              href="#"
              @click="
                () => {
                  this.perPage = '1000';
                }
              "
              >1000</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div
      v-if="customerEmployees && customerEmployees.length"
      class="col-12 mb-2 pr-4"
    >
      <a
        class="text-danger"
        data-toggle="modal"
        data-target="#modalDeleteEmployees"
        href="#"
      >
        <!-- <i class="fas fa-trash mr-2"></i>
        Excluir todos colaboradores -->
      </a>
    </div>

    <div class="col-12 pr-4 mb-2">
      <router-link
        :to="{
          name: 'customer-employee-add',
          params: { customerId: customer ? customer.id : -1 },
        }"
        id="customer-employee-add-a"
      >
        <!-- <i class="fas fa-plus mr-2"></i>
        Adicionar colaborador -->
      </router-link>
    </div>
    <div class="col-12 pr-4">
      <router-link
        :to="{
          name: 'customer-import-employee',
          params: { customerId: customer ? customer.id : -1 },
        }"
        id="customer-import-employee-a"
      >
        <!-- <i class="fas fa-file-excel mr-2"></i>
        Importar colaboradores -->
      </router-link>
    </div>
  </div>
</template>

<script>
import Modal from "../../../components/Modal.vue";
import { formatCellphone } from "../../../utils/format-fields";
import TwInput from "@/components/TwInput.vue";
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import { mapGetters } from "vuex";
export default {
  name: "EmployeeTab",
  data() {
    return {
      filter: null,
      dadoEmployees: null,
      employeeDelete: "",
      perPage: 10,
      currentPage: 1,
      rows: 1,
      sortByEmployees: "name",
      filteredEmployees: [],
      fieldsEmployees: [
        { key: "name", sortable: true, label: "Nome" },
        { key: "email", sortable: true, label: "Email" },
        { key: "cellphone", label: "Celular" },
        { key: "tag_label", label: "Tag associada" },
        { key: "mac_address", label: "Mac address" },
        { key: "actions", label: "Ações", class: "actions" },
      ],
    };
  },
  watch: {
    customer() {
      if (this.customer) {
        this.$store.dispatch("employee/getEmployees", {
          customer_id: this.customer.id,
        });
        this.$store.dispatch("tags/getCustomerTags", {
          customer_id: this.customer.id,
        });
      }
    },
    customerEmployees() {
      if (this.$options.name) {
        const ctx = JSON.parse(
          localStorage.getItem(`bstable-state-${this.$options.name}`)
        );
        if (!ctx){
          this.perPage = 10;
          this.currentPage = 1;
          this.sortBy = "";
          this.rows = this.customerEmployees.length;
          return;
        }
        if (ctx.perPage) {
          this.perPage = ctx.perPage;
        }
        if (ctx.sortBy !== "") {
          this.sortBy = ctx.sortBy;
        }
        if (this.perPage !== "" && this.perPage !== null) {
          this.currentPage = ctx.currentPage;
        }
      }
      this.rows = this.customerEmployees.length;
    },
  },
  // async mounted() {
  // this.updateList();
  // },
  methods: {
    changeBsTableState(table_state) {
      if (this.$options.name) {
        localStorage.setItem(
          `bstable-state-${this.$options.name}`,
          JSON.stringify(table_state)
        );
      }
    },
    onFiltered(customerEmployees) {
      this.rows = customerEmployees.length;
    },
    formatCellphone(cel) {
      return formatCellphone(cel);
    },
    deleteEmployee() {
      event.preventDefault();
      this.$store.dispatch("employee/deleteEmployee", {
        id: this.employeeDelete.id,
      });
    },
    deleteEmployees() {
      event.preventDefault();

      this.$store.dispatch("employee/deleteEmployees", {
        customer: this.customer,
        employees: this.customerEmployees.map((item) => item.id),
      });
    },
  },
  computed: {
    ...mapGetters({
      load: "load",
      customerTags: "tags/customerTags",
      allTags: "tags/tags",
    }),
    load() {
      return this.$store.getters["load"];
    },
    customer() {
      return this.$store.getters["customer/customer"];
    },
    customerTags() {
      return this.$store.getters["tags/customerTags"];
    },
    customerEmployees() {
      const tags = this.$store.getters["tags/customerTags"];
      const employees = this.$store.getters["employee/employees"].map(
        (dadoEmployees) => {
          // console.log("DAD", dadoEmployees);

          for (var i = 0; i < tags.length; i++) {
            if (tags[i].employee !== null) {
              if (tags[i].employee.id == dadoEmployees.id) {
                dadoEmployees.tag_label = tags[i].tag_label;
                dadoEmployees.mac_address = tags[i].mac_address;

                break;
              }
            }
          }
          return dadoEmployees;
        }
      );
      //("employees dado", employees);

      return employees;
    },
  },
  components: {
    Modal,
    TwInput,
    BDropdown,
    BDropdownItem,
  },
};
</script>

<style>
@media screen and (max-width: 1040px) {
  .iconspace {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
